import React, { useMemo } from 'react';
import { formatImgUrl } from '../util';
import { useLazyLoadImg } from '../hooks/useLazyLoadImg';

/**
 * 懒加载背景图片
 */
export const LazyBgImg = (
    props: React.HTMLAttributes<HTMLDivElement> & {
        url: string;
        width?: number;
        className?: string;
        lazyOptions?: IntersectionObserverInit;
        children?: string | JSX.Element | JSX.Element[];
    },
) => {
    const { children, width, className = '', lazyOptions } = props;
    const url = useMemo(() => formatImgUrl(props.url), [props.url, width]);
    const lazyLoadImg = useLazyLoadImg(url, lazyOptions);

    return (
        <div data-src={url} className={className} ref={lazyLoadImg}>
            {children}
        </div>
    );
};
